"use client";

import { type ReactNode } from "react";
import { CookieConsentProvider } from "@/lib/cookie-consent";
import { CookieBanner } from "@/components/CookieBanner";
import { ConsentModeUpdater } from "@/components/ConsentModeUpdater";

export function Providers({ children }: { children: ReactNode }) {
  return (
    <CookieConsentProvider>
      <ConsentModeUpdater />
      {children}
      <CookieBanner />
    </CookieConsentProvider>
  );
}
